export default "__VITE_ASSET__DbLh$DCt__"